import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { IMAGE_AREA_HEIGHT_9_16 } from 'constants/style';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      width: '100%',
    },
    overlay: {
      opacity: 0.5,
    },
    formContentBottom: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(3),
    },
    textField: {
      width: '100%',
    },
    maxTextLength: {
      color: theme.palette.text.secondary,
      marginTop: theme.spacing(1),
    },
    progress: {
      marginTop: theme.spacing(3),
    },
    inputProps: {
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.spacing(2),
      width: '100%',
      height: IMAGE_AREA_HEIGHT_9_16,
    },
    datePickerProps: {
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.spacing(1),
    },
    dialogActions: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(6),
    },
    deleteButton: {
      marginLeft: -theme.spacing(1),
    },
    editActions: {
      justifyContent: 'space-between',
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    textContent: {
      minWidth: 342,
      display: 'flex',
      flexDirection: 'column',
    },
    subTitle: {
      fontWeight: theme.typography.fontWeightMedium,
      marginBottom: theme.spacing(1),
    },
  }),
);

export default useStyles;
